import { memo } from 'react'

import LoadingSpinner from './LoadingSpinner'

const LoadingSpinnerComponent = memo(LoadingSpinner)

export default LoadingSpinnerComponent
